export default {
  title: 'Prodotti',
  buttons: {
    add_product: 'Aggiungi prodotto',
  },
  modals: {
    delete_product: {
      title: 'Sei sicuro',
      description:
        'Tutti gli abbonamenti attuali con questo prodotto rimarranno attivi, ma non sarà possibile crearne di nuovi. Questa azione non può essere annullata!',
    },
    delete_price: {
      title: 'Sei sicuro',
      description:
        'Tutti gli abbonamenti attuali con questo prezzo rimarranno attivi, ma non sarà possibile crearne di nuovi. Questa azione non può essere annullata!',
    },
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
    failed_to_delete_product: 'Eliminazione del prodotto non riuscita',
    product_got_deleted: 'Prodotto eliminato',
    failed_to_delete_price: 'Eliminazione del prezzo non riuscita',
    price_got_deleted: 'Prezzo eliminato',
  },
};
